import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import copilotStore from "Stores/copilotStore";
import SignalIcon from "Pages/Dashboard/signals/SignalIcon";
import "./homeAsk.scss";

// Starting points that read like a rep's morning, not a feature list.
const SUGGESTIONS = [
  "Which accounts heated up this week?",
  "Build a list of VP Sales at Series B SaaS in the US",
  "How did my sequences do last week?"
];

/** Ask Copilot from Home: the question goes to the full Copilot page, which keeps working on its own at /copilot. */
const HomeAsk = () => {
  const history = useHistory();
  const [q, setQ] = useState("");
  const ask = text => {
    const query = String(text || "").trim();
    if (query) copilotStore.openCopilotWith(history, query);
  };
  return (
    <form className="homeAsk" onSubmit={e => { e.preventDefault(); ask(q); }}>
      <div className="homeAsk__box">
        <span className="homeAsk__spark" aria-hidden="true"><SignalIcon id="sparkle" size={18} /></span>
        <input
          className="homeAsk__input"
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder="Ask Copilot: find companies, build a list, check how your sequences did…"
          aria-label="Ask Copilot"
        />
        <button type="submit" className="homeAsk__go" disabled={!q.trim()}>Ask</button>
      </div>
      <div className="homeAsk__chips">
        {SUGGESTIONS.map(s => (
          <button key={s} type="button" className="homeAsk__chip" onClick={() => ask(s)}>{s}</button>
        ))}
      </div>
    </form>
  );
};

export default HomeAsk;
